import React from 'react'
import { Row, Col, Tabs, } from 'antd'
import WebIntro from './WebIntro'
import WebOrgan from './WebOrgan'
import WebHonor from './WebHonor'
import WebMain from './WebMain'
function WebAbout(props) {
     const items = [
        {
            label: '公司简介',
            key: 'intro',
            children: <WebIntro />,
        },
        {
            label: '组织架构',
            key: 'organ',
            children: <WebOrgan/>,
        },
        {
            label: '资质荣誉',
            key: 'id',
            children: <WebHonor/>,
        },
     ]
    //点击量
    return (
       <WebMain selectedKeys='about'>
            <Row style={{backgroundColor:"#fff",padding:"60px"}}>            
                <Col span={5} ></Col>
                <Col span={14} >
                    <Tabs
                        tabPosition='left'
                        items={items}
                        size='large'
                    />
                </Col>
                <Col span={5}></Col>
            </Row>
       </WebMain>
    )
}

export default WebAbout